<div class="documents-item documents-content">
  @for (document of documents; track document) {
    <div class="document-content-list-item">
      <a class="document-content-list-item-link" href="{{ document.url }}" target="_blank">{{ document.name }}</a>
    </div>
  }
</div>
